export const internationalTelephoneAreaCodeList = [
  { area: "Afghanistan (‫افغانستان‬‎)", number: "93" },
  { area: "Albania (Shqipëri)", number: "355" },
  { area: "Algeria (‫الجزائر‬‎)", number: "213" },
  { area: "American Samoa", number: "684" },
  { area: "Andorra", number: "376" },
  { area: "Angola", number: "244" },
  { area: "Anguilla", number: "264" },
  { area: "Antigua and Barbuda", number: "268" },
  { area: "Argentina", number: "54" },
  { area: "Armenia (Հայաստան)", number: "374" },
  { area: "Aruba", number: "297" },
  { area: "Australia", number: "61" },
  { area: "Austria (Österreich)", number: "43" },
  { area: "Azerbaijan (Azərbaycan)", number: "994" },
  { area: "Bahamas", number: "1" },
  { area: "Bahrain (‫البحرين‬‎)", number: "973" },
  { area: "Bangladesh (বাংলাদেশ)", number: "880" },
  { area: "Barbados", number: "246" },
  { area: "Belarus (Беларусь)", number: "375" },
  { area: "Belgium (België)", number: "32" },
  { area: "Belize", number: "501" },
  { area: "Benin (Bénin)", number: "229" },
  { area: "Bermuda", number: "1" },
  { area: "Bhutan (འབྲུག)", number: "975" },
  { area: "Bolivia", number: "591" },
  { area: "Bosnia and Herzegovina (Босна и Херцеговина)", number: "387" },
  { area: "Botswana", number: "267" },
  { area: "Brazil (Brasil)", number: "55" },
  { area: "British Indian Ocean Territory", number: "246" },
  { area: "British Virgin Islands", number: "1" },
  { area: "Brunei", number: "673" },
  { area: "Bulgaria (България)", number: "359" },
  { area: "Burkina Faso", number: "226" },
  { area: "Burundi (Uburundi)", number: "257" },
  { area: "Cambodia (កម្ពុជា)", number: "855" },
  { area: "Cameroon (Cameroun)", number: "237" },
  { area: "Canada", number: "1" },
  { area: "Cape Verde (Kabu Verdi)", number: "238" },
  { area: "Caribbean Netherlands", number: "599" },
  { area: "Cayman Islands", number: "345" },
  {
    area: "Central African Republic (République centrafricaine)",
    number: "236",
  },
  { area: "Chad (Tchad)", number: "235" },
  { area: "Chile", number: "56" },
  { area: "China (中国)", number: "86" },
  { area: "Christmas Island", number: "61" },
  { area: "Colombia", number: "57" },
  { area: "Comoros (‫جزر القمر‬‎)", number: "269" },
  { area: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", number: "243" },
  { area: "Congo (Republic) (Congo-Brazzaville)", number: "242" },
  { area: "Cook Islands", number: "682" },
  { area: "Costa Rica", number: "506" },
  { area: "Côte d’Ivoire", number: "225" },
  { area: "Croatia (Hrvatska)", number: "385" },
  { area: "Cuba", number: "53" },
  { area: "Curaçao", number: "599" },
  { area: "Cyprus (Κύπρος)", number: "357" },
  { area: "Czech Republic (Česká republika)", number: "420" },
  { area: "Denmark (Danmark)", number: "45" },
  { area: "Djibouti", number: "253" },
  { area: "Dominica", number: "767" },
  { area: "Dominican Republic (República Dominicana)", number: "1" },
  { area: "Ecuador", number: "593" },
  { area: "Egypt (‫مصر‬‎)", number: "20" },
  { area: "El Salvador", number: "503" },
  { area: "Equatorial Guinea (Guinea Ecuatorial)", number: "240" },
  { area: "Eritrea", number: "291" },
  { area: "Estonia (Eesti)", number: "372" },
  { area: "Ethiopia", number: "251" },
  { area: "Falkland Islands (Islas Malvinas)", number: "500" },
  { area: "Faroe Islands (Føroyar)", number: "298" },
  { area: "Fiji", number: "679" },
  { area: "Finland (Suomi)", number: "358" },
  { area: "France", number: "33" },
  { area: "French Guiana (Guyane française)", number: "594" },
  { area: "French Polynesia (Polynésie française)", number: "689" },
  { area: "Gabon", number: "241" },
  { area: "Gambia", number: "220" },
  { area: "Georgia (საქართველო)", number: "995" },
  { area: "Germany (Deutschland)", number: "49" },
  { area: "Ghana (Gaana)", number: "233" },
  { area: "Gibraltar", number: "350" },
  { area: "Greece (Ελλάδα)", number: "30" },
  { area: "Greenland (Kalaallit Nunaat)", number: "299" },
  { area: "Grenada", number: "473" },
  { area: "Guadeloupe", number: "590" },
  { area: "Guam", number: "671" },
  { area: "Guatemala", number: "502" },
  { area: "Guernsey", number: "44" },
  { area: "Guinea (Guinée)", number: "224" },
  { area: "Guinea-Bissau (Guiné Bissau)", number: "245" },
  { area: "Guyana", number: "592" },
  { area: "Haiti", number: "509" },
  { area: "Honduras", number: "504" },
  { area: "Hong Kong (香港)", number: "852" },
  { area: "Hungary (Magyarország)", number: "36" },
  { area: "Iceland (Ísland)", number: "354" },
  { area: "India (भारत)", number: "91" },
  { area: "Indonesia", number: "62" },
  { area: "Iran (‫ایران‬‎)", number: "98" },
  { area: "Iraq (‫العراق‬‎)", number: "964" },
  { area: "Ireland", number: "353" },
  { area: "Isle of Man", number: "44" },
  { area: "Israel (‫ישראל‬‎)", number: "972" },
  { area: "Italy (Italia)", number: "39" },
  { area: "Jamaica", number: "876" },
  { area: "Japan (日本)", number: "81" },
  { area: "Jersey", number: "44" },
  { area: "Jordan (‫الأردن‬‎)", number: "962" },
  { area: "Kazakhstan (Казахстан)", number: "7" },
  { area: "Kenya", number: "254" },
  { area: "Kiribati", number: "686" },
  { area: "Kosovo", number: "383" },
  { area: "Kuwait (‫الكويت‬‎)", number: "965" },
  { area: "Kyrgyzstan (Кыргызстан)", number: "996" },
  { area: "Laos (ລາວ)", number: "856" },
  { area: "Latvia (Latvija)", number: "371" },
  { area: "Lebanon (‫لبنان‬‎)", number: "961" },
  { area: "Lesotho", number: "266" },
  { area: "Liberia", number: "231" },
  { area: "Libya (‫ليبيا‬‎)", number: "218" },
  { area: "Liechtenstein", number: "423" },
  { area: "Lithuania (Lietuva)", number: "370" },
  { area: "Luxembourg", number: "352" },
  { area: "Macau (澳門)", number: "853" },
  { area: "Macedonia (FYROM) (Македонија)", number: "389" },
  { area: "Madagascar (Madagasikara)", number: "261" },
  { area: "Malawi", number: "265" },
  { area: "Malaysia", number: "60" },
  { area: "Maldives", number: "960" },
  { area: "Mali", number: "223" },
  { area: "Malta", number: "356" },
  { area: "Marshall Islands", number: "692" },
  { area: "Martinique", number: "596" },
  { area: "Mauritania (‫موريتانيا‬‎)", number: "222" },
  { area: "Mauritius (Moris)", number: "230" },
  { area: "Mayotte", number: "262" },
  { area: "Mexico (México)", number: "52" },
  { area: "Micronesia", number: "691" },
  { area: "Moldova (Republica Moldova)", number: "373" },
  { area: "Monaco", number: "377" },
  { area: "Mongolia (Монгол)", number: "976" },
  { area: "Montenegro (Crna Gora)", number: "382" },
  { area: "Montserrat", number: "1" },
  { area: "Morocco (‫المغرب‬‎)", number: "212" },
  { area: "Mozambique (Moçambique)", number: "258" },
  { area: "Myanmar (Burma) (မြန်မာ)", number: "95" },
  { area: "Namibia (Namibië)", number: "264" },
  { area: "Nauru", number: "674" },
  { area: "Nepal (नेपाल)", number: "977" },
  { area: "Netherlands (Nederland)", number: "31" },
  { area: "New Caledonia (Nouvelle-Calédonie)", number: "687" },
  { area: "New Zealand", number: "64" },
  { area: "Nicaragua", number: "505" },
  { area: "Niger (Nijar)", number: "227" },
  { area: "Nigeria", number: "234" },
  { area: "Niue", number: "683" },
  { area: "Norfolk Island", number: "672" },
  { area: "North Korea (조선 민주주의 인민 공화국)", number: "850" },
  { area: "Northern Mariana Islands", number: "1" },
  { area: "Norway (Norge)", number: "47" },
  { area: "Oman (‫عُمان‬‎)", number: "968" },
  { area: "Pakistan (‫پاکستان‬‎)", number: "92" },
  { area: "Palau", number: "680" },
  { area: "Palestine (‫فلسطين‬‎)", number: "970" },
  { area: "Panama (Panamá)", number: "507" },
  { area: "Papua New Guinea", number: "675" },
  { area: "Paraguay", number: "595" },
  { area: "Peru (Perú)", number: "51" },
  { area: "Philippines", number: "63" },
  { area: "Poland (Polska)", number: "48" },
  { area: "Portugal", number: "351" },
  { area: "Puerto Rico", number: "1" },
  { area: "Qatar (‫قطر‬‎)", number: "974" },
  { area: "Réunion (La Réunion)", number: "262" },
  { area: "Romania (România)", number: "40" },
  { area: "Russia (Россия)", number: "7" },
  { area: "Rwanda", number: "250" },
  { area: "Saint Barthélemy", number: "590" },
  { area: "Saint Helena", number: "290" },
  { area: "Saint Kitts and Nevis", number: "869" },
  { area: "Saint Lucia", number: "758" },
  { area: "Saint Martin (Saint-Martin (partie française))", number: "590" },
  {
    area: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    number: "508",
  },
  { area: "Saint Vincent and the Grenadines", number: "784" },
  { area: "Samoa", number: "685" },
  { area: "San Marino", number: "378" },
  { area: "São Tomé and Príncipe (São Tomé e Príncipe)", number: "239" },
  { area: "Saudi Arabia (‫المملكة العربية السعودية‬‎)", number: "966" },
  { area: "Senegal (Sénégal)", number: "221" },
  { area: "Serbia (Србија)", number: "381" },
  { area: "Seychelles", number: "248" },
  { area: "Sierra Leone", number: "232" },
  { area: "Singapore", number: "65" },
  { area: "Sint Maarten", number: "599" },
  { area: "Slovakia (Slovensko)", number: "421" },
  { area: "Slovenia (Slovenija)", number: "386" },
  { area: "Solomon Islands", number: "677" },
  { area: "Somalia (Soomaaliya)", number: "252" },
  { area: "South Africa", number: "27" },
  { area: "South Korea (대한민국)", number: "82" },
  { area: "South Sudan (‫جنوب السودان‬‎)", number: "211" },
  { area: "Spain (España)", number: "34" },
  { area: "Sri Lanka (ශ්‍රී ලංකාව)", number: "94" },
  { area: "Sudan (‫السودان‬‎)", number: "249" },
  { area: "Suriname", number: "597" },
  { area: "Svalbard and Jan Mayen", number: "47" },
  { area: "Swaziland", number: "268" },
  { area: "Sweden (Sverige)", number: "46" },
  { area: "Switzerland (Schweiz)", number: "41" },
  { area: "Syria (‫سوريا‬‎)", number: "963" },
  { area: "Taiwan (台灣)", number: "886" },
  { area: "Tajikistan", number: "992" },
  { area: "Tanzania", number: "255" },
  { area: "Thailand (ไทย)", number: "66" },
  { area: "Timor-Leste", number: "670" },
  { area: "Togo", number: "228" },
  { area: "Tokelau", number: "690" },
  { area: "Tonga", number: "676" },
  { area: "Trinidad and Tobago", number: "868" },
  { area: "Tunisia (‫تونس‬‎)", number: "216" },
  { area: "Turkey (Türkiye)", number: "90" },
  { area: "Turkmenistan", number: "993" },
  { area: "Turks and Caicos Islands", number: "1" },
  { area: "Tuvalu", number: "688" },
  { area: "U.S. Virgin Islands", number: "340" },
  { area: "Uganda", number: "256" },
  { area: "Ukraine (Україна)", number: "380" },
  { area: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", number: "971" },
  { area: "United Kingdom", number: "44" },
  { area: "United States", number: "1" },
  { area: "Uruguay", number: "598" },
  { area: "Uzbekistan (Oʻzbekiston)", number: "998" },
  { area: "Vanuatu", number: "678" },
  { area: "Vatican City (Città del Vaticano)", number: "379" },
  { area: "Venezuela", number: "58" },
  { area: "Vietnam (Việt Nam)", number: "84" },
  { area: "Wallis and Futuna (Wallis-et-Futuna)", number: "681" },
  { area: "Western Sahara (‫الصحراء الغربية‬‎)", number: "212" },
  { area: "Yemen (‫اليمن‬‎)", number: "967" },
  { area: "Zambia", number: "260" },
  { area: "Zimbabwe", number: "263" },
  { area: "Åland Islands", number: "358" },
];
